<div class="side-nav" [class.side-nav--open]="isCollapsed" *transloco="let t; read: 'app.sideNav'">
  <a class="side-nav__logo" href="javascript:;" (click)="navigateToUrl(logoNavigateTo())">
    <app-svg-icon
      class="side-nav__logo-img"
      [icon]="'assets/images/header-logo.svg'"
      [blank]="true"
    ></app-svg-icon>
  </a>
  <div class="side-nav__menu-wrapper">
    <div class="side-nav__menu">
      <ul class="side-nav__nav">
        <li class="side-nav__section cta-btn-wrapper">
          <app-button
            type="primary"
            size="large"
            (onClick)="commonService.showSidenav(); navigateToUrl(newChallengeNavigateTo())"
          >
            {{ t("newChallenge") }}
            <app-svg-icon
              class="arrow-icon"
              [icon]="'assets/images/icon-arrow.svg'"
              [blank]="true"
            ></app-svg-icon>
          </app-button>
        </li>

        <li class="side-nav__section">
          <span class="side-nav__section-label">{{ t("heading") }}</span>
        </li>

        @for (item of menuItems(); track item.navigateTo) {
          <app-side-nav-item
            [label]="t(item.labelKey)"
            [navigateTo]="item.navigateTo"
            [image]="item.image"
            [exactMatch]="item.exactMatch ?? false"
            [alsoActiveFor]="item.alsoActiveFor ?? []"
          />
        }
      </ul>
    </div>
  </div>
  <div class="side-nav__footer">
    @if (isMobile$ | async) {
      <app-language-dropdown [openAbove]="true" />
      <app-theme-switcher (click)="commonService.showSidenav()"></app-theme-switcher>
    }
  </div>
</div>

@if (isCollapsed) {
  <div class="side-nav__overlay" (click)="commonService.showSidenav()"></div>
}
